import { getWalletAddress, getWalletProviderId, hasAuthSession } from '@/utils/auth-token';
import { getSessionLoginType } from '@/utils/user-session-profile';

/**
 * 登录轨 → 资金/签名通道（以本次 originLoginType 为准，见 getSessionLoginType）：
 * - EMAIL / GOOGLE → Privy 托管
 * - WALLET → 当前连接 EOA，不依赖 trade-address 绑定
 * 合并账号曾注册 Google 再切钱包登录时，不得因历史 registerType 误入托管轨。
 */
export function sessionExpectsCustodialWallet() {
  if (!hasAuthSession()) return false;
  const origin = String(getSessionLoginType() ?? '')
    .trim()
    .toUpperCase();
  if (origin === 'EMAIL' || origin === 'GOOGLE') return true;
  if (origin === 'WALLET') return false;
  if (getWalletProviderId() === 'privy') return true;
  const provider = String(getWalletProviderId() ?? '')
    .trim()
    .toLowerCase();
  if (provider && provider !== 'privy') return false;
  if (String(getWalletAddress() ?? '').trim()) return false;
  return true;
}

export function sessionExpectsSelfCustodyWallet() {
  return hasAuthSession() && !sessionExpectsCustodialWallet();
}
